import { downloadBase64File } from "../../../../../common/utils/download_utils";
import { ReportMimeType } from "../../../../../common/utils/report_callback";
import { IGetReportChecklistEntregaListaUseCase } from "../../../presentation/useCases/read/get_report_checklist_entrega_lista_use_case";
import { ReportData } from "../../models/report_data";
import { IReportsRepository } from "../../repositories/reports_repository";

/**
 * GetReportChecklistEntregaListaUseCase
 */

export class GetReportChecklistEntregaListaUseCase implements IGetReportChecklistEntregaListaUseCase {
  constructor(private readonly repository: IReportsRepository) { }

  async getReportChecklistEntregaLista(
    requiredMimeType: ReportMimeType | null,
    idChecklistEntrega: number,
  ): Promise<ReportData> {
    const response = await this.repository.getReportChecklistEntregaLista(
      requiredMimeType,
      idChecklistEntrega,
    );

    if (response.mimeType !== 'text/html') {
      const temporaryFilename = `${response.filename}.${response.filenameExtension}`;

      const arquivoNome = response.filename === null || response.filename === undefined || response.filename.trim() === '' ||
        response.filenameExtension === null || response.filenameExtension === undefined || response.filenameExtension.trim() === ''
        ? temporaryFilename
        : `${response.filename}.${response.filenameExtension}`;

      const arquivo = response.bytes;
      await downloadBase64File(arquivoNome, arquivo);

    }
    return response;
  }
}
